import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAuditoriaPrestadores,
  descargarDetalleAuditoria,
  getAuditActionTypes,
  getAuditoriaDetalle,
  getAuditoriaPrestadores,
} from "../../../../actions/audit";
import { StyledArtSearchContainer } from "../../../styled/accident";
import AuditoriaPrestadoresDetalleDialog from "./auditoriaPrestadoresDetalleDialog";
import AuditoriaPrestadoresSearch from "./auditoriaPrestadoresSearch";
import AuditoriaPrestadoresTable from "./auditoriaPrestadoresTable";

const AuditoriaPrestadoresContainer = () => {
  const dispatch = useDispatch();
  const consulta = useSelector((state) => state.audit.consulta);
  const actionTypes = useSelector((state) => state.audit.actionTypes);
  const detalle = useSelector((state) => state.audit.detalle);
  const [filtros, setFiltros] = useState(null);
  const [detalleAbierto, setDetalleAbierto] = useState(false);
  const [filaDetalle, setFilaDetalle] = useState(null);

  useEffect(() => {
    dispatch(getAuditActionTypes());
    return () => {
      dispatch(clearAuditoriaPrestadores());
    };
  }, [dispatch]);

  const handleSearch = (params) => {
    setFiltros(params);
    dispatch(getAuditoriaPrestadores(params));
  };

  const handleReset = () => {
    setFiltros(null);
    dispatch(clearAuditoriaPrestadores());
  };

  const handleVerDetalle = (fila) => {
    setFilaDetalle(fila);
    setDetalleAbierto(true);
    dispatch(getAuditoriaDetalle(fila.idMovimientoLog, fila.origen));
  };

  const handleDownload = ({ contenido, extension, lado }) => {
    dispatch(descargarDetalleAuditoria(detalle.data, contenido, extension, lado));
  };

  return (
    <StyledArtSearchContainer.Container>
      <StyledArtSearchContainer.Title>Auditoría de Prestadores</StyledArtSearchContainer.Title>
      <AuditoriaPrestadoresSearch
        isSearching={consulta.isFetching}
        actionTypes={actionTypes.data}
        handleSearch={handleSearch}
        handleReset={handleReset}
      />
      <AuditoriaPrestadoresTable
        data={consulta.data}
        loading={consulta.isFetching}
        fetchData={filtros ? () => dispatch(getAuditoriaPrestadores(filtros)) : undefined}
        onVerDetalle={handleVerDetalle}
      />
      <AuditoriaPrestadoresDetalleDialog
        open={detalleAbierto}
        onClose={() => setDetalleAbierto(false)}
        fila={filaDetalle}
        detalle={detalle.data}
        loading={detalle.isFetching}
        onDownload={handleDownload}
      />
    </StyledArtSearchContainer.Container>
  );
};

export default AuditoriaPrestadoresContainer;
